/* eslint-disable no-var, vars-on-top */
var Cookies = require('js-cookie');
var root = 'undefined' === typeof window ? global : window;

function Storage() {
    this.data = {};
}

function isStorageSupported(rootArg, key) {
    try {
        // FINDING-1393 - trying this first fixes private mode browsing in safari
        // https://github.com/marcuswestin/store.js/issues/42
        rootArg[key].setItem('dibsy', '');
        rootArg[key].removeItem('dibsy');
        return true;
    } catch (e) {
        return false;
    }
}

Storage.prototype = {
    _storage: {},
    _supported: false,
    initialize: function(rootArg, key) {
        if (isStorageSupported(rootArg, key)) {
            this._storage = rootArg[key];
            this._supported = true;
        }
        return this;
    },
    isSupported: function() {
        return this._supported;
    },
    /**
     * Sets whether or not local/session storage is supported
     * @param {boolean} supported
     */
    setSupported: function(supported) {
        this._supported = supported;
    },
    getItems: function() {
        if (!this._supported) {
            return 'localStorage is not supported';
        }
        return this._storage;
    },
    /**
     * Set storage value by the key
     *
     * @param key - {string}
     * @param value - {mixed}
     * @returns {Storage}
     */
    setItem: function(key, value) {
        switch (typeof value) {
            case 'object':
                value = JSON.stringify(value);
                break;
            default:
                value += '';
        }

        if (!this._supported) {
            this.data[key] = value;
            Cookies.set(key, value, { path: '/', domain: '.1stdibs.com' });
        } else {
            try {
                this._storage.setItem(key, value);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
    /**
     * Get storage value by the key
     *
     * @param key - {string}
     * @returns {mixed}
     */
    getItem: function(key) {
        var value;

        if (!key) {
            return false;
        }
        if (!this._supported) {
            value = Cookies.get(key);
            if (!value && this.data[key]) {
                value = this.data[key];
            }
        } else {
            value = this._storage[key];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    /**
     * Delete storage by the key
     *
     * @param key - {string}
     * @returns {Storage}
     */
    deleteItem: function(key) {
        if (!this._supported) {
            delete this.data[key];
            Cookies.remove(key, { path: '/' });
        } else {
            try {
                this._storage.removeItem(key);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
};

var LocalStorage = new Storage();
var SessionStorage = new Storage();

module.exports = {
    localStorage: LocalStorage.initialize(root, 'localStorage'),
    sessionStorage: SessionStorage.initialize(root, 'sessionStorage'),
};
